import React from 'react';
import { XCircle } from 'lucide-react';

/**
 * Validation Results Component
 * Displays recent batch validation results
 * @param {Object} props - Component props
 * @param {Array} props.batchResults - Array of batch validation results
 * @returns {JSX.Element} Validation results display
 */
export function ValidationResults({ batchResults = [] }) {
    // Don't render anything if there are no results
    if (!batchResults || batchResults.length === 0) {
        return null;
    }

    return (
        <div className="bg-white rounded-xl p-6 shadow-sm border border-slate-200">
            <h3 className="text-lg font-semibold text-slate-900 mb-6">Recent Batch Results</h3>
            <div className="space-y-3">
                {batchResults.map((result, index) => (
                    <div key={index} className="flex items-center justify-between p-4 border border-slate-200 rounded-lg">
                        <div>
                            <div className="font-medium text-slate-900">{result.storeName}</div>
                            <div className="text-sm text-slate-500">
                                {new Date(result.timestamp).toLocaleString()}
                            </div>
                        </div>
                        <div>
                            {result.error ? (
                                <div className="flex items-center gap-2 text-red-600">
                                    <XCircle size={16} />
                                    <span className="text-sm">Error: {result.error}</span>
                                </div>
                            ) : (
                                <div className={`
                  px-3 py-1 rounded-full text-sm font-medium
                  ${result.validationResult?.overallScore >= 80 ? 'bg-emerald-100 text-emerald-700' :
                                        result.validationResult?.overallScore >= 60 ? 'bg-amber-100 text-amber-700' : 'bg-red-100 text-red-700'}
                `}>
                                    Score: {result.validationResult?.overallScore || 0}%
                                </div>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default ValidationResults;
